export enum EModalStatus {
  Hide = 'hide',
  Open = 'open',
}

export enum EModalSource {
  Consultation = 'consultation',
  Form = 'form',
  QualityCriteria = 'qualityCriteria',
}

export type TModalStatus = {
  status: EModalStatus;
  source?: EModalSource;
};
